export default __webpack_public_path__ + "static/media/Group1028.d99e20d2.svg";